import Image from "next/image";
import { cn } from "@/lib/utils";
import type { PreviewImageDto } from "@/lib/services/productService";

interface CarouselThumbnailsProps {
  thumbnails: PreviewImageDto[];
  selectedIndex: number;
  onThumbnailHover: (index: number) => void;
  onThumbnailLeave: () => void;
}

export function CarouselThumbnails({
  thumbnails,
  selectedIndex,
  onThumbnailHover,
  onThumbnailLeave,
}: CarouselThumbnailsProps) {
  return (
    <div className="hidden lg:grid grid-rows-4 gap-3 h-full" onMouseLeave={onThumbnailLeave}>
      {thumbnails.map((thumbnail, index) => (
        <button
          key={index}
          onMouseEnter={() => onThumbnailHover(index)}
          className={cn(
            "relative overflow-hidden border rounded-lg bg-card",
            selectedIndex === index
              ? "border-foreground"
              : "border-border"
          )}
          aria-label={`View screenshot ${index + 1}`}
        >
          <Image
            src={thumbnail.imageUrl}
            alt={`Thumbnail ${index + 1}`}
            width={320}
            height={180}
            className="w-full h-full object-cover"
            unoptimized={true}
          />

          {/* Active indicator */}
          {selectedIndex === index && (
            <div className="absolute top-2 right-2 w-2 h-2 rounded-full bg-foreground" />
          )}
        </button>
      ))}
    </div>
  );
}
